import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { freightServiceConfigSchema } from '../configurations/FreightServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderFreightDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.FREIGHT]: freightServiceConfigSchema,
    }),
});

export { servicesProviderFreightDataSchema };
//# sourceMappingURL=ServicesProviderFreightData.js.map
